export default "__VITE_ASSET__DH37zuqi__"